import { render } from "./MPrintHeader.vue?vue&type=template&id=4a055577&ts=true"
import script from "./MPrintHeader.vue?vue&type=script&lang=ts"
export * from "./MPrintHeader.vue?vue&type=script&lang=ts"

import "./MPrintHeader.vue?vue&type=style&index=0&id=4a055577&lang=css"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__